import axios from "../../axios";

// Initial state
const initialState = {
    loading: false,
    data: [],
    error: null
};

// Action Types
export const SUBCATEGORY_REQUEST = 'SUBCATEGORY_REQUEST';
export const SUBCATEGORY_SUCCESS = 'SUBCATEGORY_SUCCESS';
export const SUBCATEGORY_FAILURE = 'SUBCATEGORY_FAILURE';

// Action Creators
export const fetchSubcategories = (categoryId) => ({
    type: SUBCATEGORY_REQUEST,
    payload: categoryId
});

export const fetchSubcategoriesSuccess = (data) => ({
    type: SUBCATEGORY_SUCCESS,
    payload: data
});

export const fetchSubcategoriesFailure = (error) => ({
    type: SUBCATEGORY_FAILURE,
    payload: error
});

// Thunk Action Creator for handling async operations
export const getSubcategories = (categoryId) => {
    return async (dispatch) => {
        dispatch(fetchSubcategories(categoryId));

        try {
            const response = await axios.get(`subcat/category/${categoryId}`);

            if (response.data && response.data.data) {
                dispatch(fetchSubcategoriesSuccess(response.data.data));
            } else {
                throw new Error('Invalid response structure');
            }
        } catch (error) {
            dispatch(fetchSubcategoriesFailure(error instanceof Error ? error : new Error('Unknown error')));
        }
    };
};

// Reducer
export const subcategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUBCATEGORY_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case SUBCATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            };
        case SUBCATEGORY_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload
            };
        default:
            return state;
    }
};

export default subcategoryReducer; 